import { useTranslation } from 'react-i18next'

import Button, { Variant } from 'common/components/button'
import Icons from 'common/components/icons'
import HTML from 'common/components/html'

import './confirmLead.scss'

interface Props {
  name: string,
  onConfirm: () => void,
  onCancel: () => void
}

const ConfirmLead = ({ onConfirm, onCancel, name }: Props) => {
  const { t } = useTranslation()

  return (
    <div className="confirm-login" data-test="confirm-lead">
      <div className="top">
        <Icons prefix="fal" iconName="user-shield" />
        <span className="title">
          {t('confirmLogin.hello')}, {name}!
        </span>
        <HTML className="message">{t('confirmLogin.text_one')}</HTML>
      </div>
      <div className="footer">
        <HTML className="message">{t('confirmLogin.text_two')}</HTML>
        <span className="message msg-continue">
          {t('confirmLogin.text_continue')}
        </span>
        <div className="buttons">
          <Button variant={Variant.SECONDARY} onClick={onCancel}>
            {t('confirmLogin.cancel')}
          </Button>
          <Button variant={Variant.PRIMARY} onClick={onConfirm} data-test="confirm-lead-button">
            {t('confirmLogin.confirm')}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmLead
